import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { LangdingPageNavBarComponent } from '../../../components/langding-page-nav-bar/langding-page-nav-bar.component';
import { SuggestionsComponent } from '../../../components/suggestions/suggestions.component';

@Component({
  selector: 'app-suggestions-menu',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, LangdingPageNavBarComponent, SuggestionsComponent],
  templateUrl: './suggestions-menu.component.html',
  styleUrls: ['./suggestions-menu.component.scss']
})
export class SuggestionsMenuComponent implements OnInit , OnDestroy {
  divHeight
  //Dev Code
  @ViewChild('landingside1') menuElement: ElementRef;
  @ViewChild('landingside2') menuElement1: ElementRef;
  @Input() page: any;


  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  csshide: Boolean = false
  elementPosition: any;
  WidgetList: any = [];
  userId: any = localStorage.getItem('userId');
  userType: any = localStorage.getItem('userType');
  pathData: any;
  selectedmenu: any;


  constructor(private api: ApiService, private provider : countProvider,
    private route: ActivatedRoute ) { 
      provider.clear();
    }

  ngOnDestroy(): void {
    this.provider.clear();
  }

  ngOnInit() {
//window.scroll(0, 0);
    this.route.queryParams.subscribe((res) => {
      this.page = res.master;
      this.pathData = res;
      this.selectedmenu = { 'menu': this.pathData.menu, 'widgetName': this.pathData.widgetName };
      this.pathData.menu;
      this.apicall();
    });


    if (window.innerHeight == 500 && window.innerWidth == 1093) {
      this.csshide = true;
    } else if (window.innerHeight > 500 && window.innerWidth > 1093) {
      this.csshide = true;
    } else if (window.innerHeight < 500 && window.innerWidth < 1093) {
      this.csshide = true;
    }

  }

  showPage:boolean=true;
  clickmenu(item) {
    this.provider.clear(); 
    this.selectedmenu = { 'menu': item.widgetDesc, 'widgetName': item.widgetName };
    this.selectedmenu ={...this.selectedmenu};
   }

  // @HostListener('window:scroll')
  // handleScroll() {
  //   const windowScroll = window.pageYOffset;
  //   if (windowScroll >= 24) {
  //     this.landingsidesticky1 = true;
  //     this.landingsidesticky2 = true;

  //   } else {
  //     this.landingsidesticky1 = false;
  //     this.landingsidesticky2 = false;
  //   }
  // }

  @HostListener("window:resize")
  onResize() {
    if (window.innerHeight == 500 && window.innerWidth == 1093) {
      //this.landingsidesticky1 = false;
      //this.landingsidesticky2 = true;
      this.csshide = true;
    } else if (window.innerHeight > 500 && window.innerWidth > 1093) {
      //this.landingsidesticky1 = false;
      // this.landingsidesticky2 = true;
      this.csshide = true;
    } else if (window.innerHeight < 500 && window.innerWidth < 1093) {
      this.csshide = false;
    }
  }

  get isBENCHorJOBEEKER() : boolean {
    return this.userType == 'BENCH_RECRUITER' || this.userType === "JOB_SEEKER"
  }

  apicall() {

    if (this.page && this.page != "" && this.page != null && this.page != undefined) {
      let data: any = {}
      let tempList: any = [];
      data.page = this.page;
      // this.util.startLoader();
      this.api.create('widget/list', data).subscribe(res => {
        if (res != undefined) {
          // Define page-specific whitelists - widgets in these lists should always appear in sidebar
          // Widgets excluded from sidebar (no max/expanded views):
          const excludedWidgets = [
            'BUSINESS_COMPLETION', 'BUSINESS_PROFILE_COMPLETE',
            'INVITE_CONNECTIONS', 'INVITE_YOUR_CONNECTION', 'INVITE_COLLEGUE',
            'VISITORS', 'PROMOTED_AD', 'SPONSORED_AD',
            'COMMUNITY_ADMIN', 'PEOPLE_IN_YOUR_NETWORK', 'BUSINESS_TO_FOLLOW'
          ];

          const pageWhitelists: { [key: string]: string[] } = {
            'BUSINESS_HOME_PAGE': ['JOBS_YOU_MIGHT_BE_INTERESTED_IN', 'PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_LANDING_HOME_PAGE': ['JOBS_YOU_MIGHT_BE_INTERESTED_IN', 'PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_COMMUNITY_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_EMPLOYEE_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_EMPLOYEE_REQ_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_JOB_PAGE': ['JOBS_YOU_MIGHT_BE_INTERESTED_IN', 'PEOPLE_YOU_MAY_KNOW', 'CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN'],
            'BUSINESS_FOLLOWR_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_ANALYTIC_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_ADMIN_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'BUSINESS_DEACTIVATE_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'COMMUNITY_HOME_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'COMMUNITY_MEMBER_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'NETWORK_HOME_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'NETWORK_ABOUT_PAGE': ['PEOPLE_YOU_MAY_KNOW'],
            'NETWORK_MEMBER_PAGE': ['PEOPLE_YOU_MAY_KNOW']
          };

          const currentPageWhitelist = pageWhitelists[this.page] || [];

          res.forEach(element => {
            // Skip disabled widgets (kept in codebase but not in use)
            if (element.widgetName === 'CToFollowComponent' || element.widgetId === 'COMMUNITY_TO_FOLLOW') {
              return;
            }

            // Skip widgets that don't have max/expanded views
            if (excludedWidgets.includes(element.widgetId)) {
              return;
            }

            // Show widget in sidebar if:
            // 1. viewType is true OR maxView is true (has "View More" button), OR
            // 2. Widget is in the current page's whitelist
            const isInWhitelist = currentPageWhitelist.includes(element.widgetId);
            if (element.viewType == true || element.maxView == true || isInWhitelist) {
              tempList.push(element)

              if (this.isBENCHorJOBEEKER && element.widgetId == "CANDIDATE_INVITE") {
                tempList.pop();
              }
              else if (this.userType == 'RECRUITER' && element.widgetId == "RESUME_REQUEST") {
                tempList.pop();
              }
              else if (this.userType == 'RECRUITER' && element.widgetId == "JOB_APPLIEDBY_CANDIDATES") {
                tempList.pop();
              }
              else if (this.userType == 'RECRUITER' && element.widgetId == "JOB_INVITES") {
                //console.log(element.widgetId +"gfhgghg");
                tempList.pop();
              }
              else if (this.userType == 'RECRUITER' && element.widgetId == "FEATURED_JOB") {
                tempList.pop();
              }
              else if (this.userType == 'RECRUITER' && element.widgetId == "SUGGESTED_JOB") {
                tempList.pop();
              }
              else if (this.isBENCHorJOBEEKER && element.widgetId == "SUGGESTED_CANDIDATE") {
                tempList.pop();
              }
              else if (this.isBENCHorJOBEEKER && element.widgetId == "RESUME_REQUEST_SENT") {
                tempList.pop();
              }
              else if (this.isBENCHorJOBEEKER && element.widgetId == "JOB_INVITE_SENT") {
                tempList.pop();
              }
              else if (this.isBENCHorJOBEEKER && element.widgetId == "FEATURED_CANDIDATE") {
                tempList.pop();
              }
              else if ( this.userType == "JOB_SEEKER" && element.widgetId == "CANDIDATE_INVITE") {
                tempList.pop();
              }else if ( this.isBENCHorJOBEEKER && element.widgetId == "CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN") {
                tempList.pop();
              }else if (this.userType == 'RECRUITER' && element.widgetId == "JOBS_YOU_MIGHT_BE_INTERESTED_IN"
                && this.page != "BUSINESS_HOME_PAGE" && this.page != "BUSINESS_LANDING_HOME_PAGE") {
                tempList.pop();
              }
            }

            if (this.page == "GIG_HOME_PAGE") {
              // Filter out TRENDING_TODAY and BUSINESS_TO_FOLLOW for GIG_HOME_PAGE
              if (element.widgetId == "TRENDING_TODAY" || element.widgetId == "BUSINESS_TO_FOLLOW") {
                // Skip these widgets - don't add to tempList
                return;
              }

              if ( this.isBENCHorJOBEEKER
                && (element.widgetId == "JOBS_YOU_MIGHT_BE_INTERESTED_IN"
                  || element.widgetId == "SUGGESTED_JOB"
                  || element.widgetId == "FEATURED_JOB")) {
                 tempList.push(element);
              }
              if (this.userType == 'RECRUITER' &&
                (element.widgetId == "CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN"
                  || element.widgetId == "FEATURED_CANDIDATE"
                  || element.widgetId == "SUGGESTED_CANDIDATE")
                ) {
                  tempList.push(element)
                }
              if (
                (this.userType == 'FREELANCE_RECRUITER' || this.userType == 'MANAGEMENT_TALENT_ACQUISITION')
                && (element.widgetId == "SUGGESTED_JOB"
                  || element.widgetId == "FEATURED_JOB"
                  || element.widgetId == "SUGGESTED_CANDIDATE"
                  || element.widgetId == "FEATURED_CANDIDATE"
                  || element.widgetId == "JOBS_YOU_MIGHT_BE_INTERESTED_IN"
                  || element.widgetId == "CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN"
                  || element.widgetId == "PEOPLE_YOU_MAY_KNOW")) {
                    tempList.push(element)
                  }
            }

            // BUSINESS_LANDING_HOME_PAGE: Keep only specific widgets
            if (this.page == "BUSINESS_LANDING_HOME_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD", "JOBS_YOU_MIGHT_BE_INTERESTED_IN"];
              if (!allowedWidgets.includes(element.widgetId)) {
                // Remove this widget if not in allowed list
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // COMMUNITY_HOME_PAGE: Keep only specific widgets
            if (this.page == "COMMUNITY_HOME_PAGE") {
              const allowedWidgets = ["COMMUNITY_ADMIN", "PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD"];
              if (!allowedWidgets.includes(element.widgetId)) {
                // Remove this widget if not in allowed list
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // COMMUNITY_MEMBER_PAGE: Hide Trending Posts widget
            if (this.page == "COMMUNITY_MEMBER_PAGE") {
              if (element.widgetId == "TRENDING_POST" || element.widgetName == "TrendingPostComponent") {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_HOME_PAGE: Keep only specific widgets (aligned with common-widget)
            if (this.page == "BUSINESS_HOME_PAGE") {
              const allowedWidgets = [
                "JOBS_YOU_MIGHT_BE_INTERESTED_IN",
                "PEOPLE_YOU_MAY_KNOW",
                "PROMOTED_AD",
                "SPONSORED_AD",
                "BUSINESS_PROFILE_COMPLETE",
                "BUSINESS_COMPLETION",
                "INVITE_CONNECTIONS",
                "INVITE_YOUR_CONNECTION",
                "VISITORS"
              ];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_COMMUNITY_PAGE: Keep specific widgets including VISITORS
            if (this.page == "BUSINESS_COMMUNITY_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD", "VISITORS"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // Business Employee and Network pages: Keep only specific widgets
            if (["BUSINESS_EMPLOYEE_PAGE", "BUSINESS_EMPLOYEE_REQ_PAGE", "NETWORK_HOME_PAGE", "NETWORK_ABOUT_PAGE", "NETWORK_MEMBER_PAGE"].includes(this.page)) {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_JOB_PAGE: Keep specific widgets including Jobs you might be interested in
            if (this.page === "BUSINESS_JOB_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD", "CANDIDATE_YOU_MIGHT_BE_INTERESTED_IN", "JOBS_YOU_MIGHT_BE_INTERESTED_IN"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_FOLLOWR_PAGE: Keep only specific widgets (for follower, followerRequest-sent pages)
            if (this.page === "BUSINESS_FOLLOWR_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_ANALYTIC_PAGE: Keep only specific widgets
            if (this.page === "BUSINESS_ANALYTIC_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_ADMIN_PAGE: Keep only specific widgets (for admin, business-settings pages)
            if (this.page === "BUSINESS_ADMIN_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD", "VISITORS"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }

            // BUSINESS_DEACTIVATE_PAGE: Keep only specific widgets
            if (this.page === "BUSINESS_DEACTIVATE_PAGE") {
              const allowedWidgets = ["PEOPLE_YOU_MAY_KNOW", "PROMOTED_AD", "SPONSORED_AD"];
              if (!allowedWidgets.includes(element.widgetId)) {
                const idx = tempList.indexOf(element);
                if (idx > -1) {
                  tempList.splice(idx, 1);
                }
              }
            }
          });
          this.WidgetList = Array.from(new Set(tempList));

          // Ensure the currently selected widget is always in the list
          // This fixes the issue where a widget clicked from "More" button doesn't appear in sidebar
          if (this.pathData && this.pathData.widgetName) {
            const selectedWidgetInList = this.WidgetList.find(
              (w: any) => w.widgetName === this.pathData.widgetName
            );

            if (!selectedWidgetInList) {
              // Find the selected widget from the original API response
              const selectedFromApi = res.find(
                (w: any) => w.widgetName === this.pathData.widgetName
              );

              if (selectedFromApi) {
                // Add the selected widget to the beginning of the list
                this.WidgetList.unshift(selectedFromApi);
              } else {
                // Widget not in API response, create a placeholder entry
                this.WidgetList.unshift({
                  widgetName: this.pathData.widgetName,
                  widgetDesc: this.pathData.menu || this.pathData.widgetName,
                  widgetId: this.pathData.widgetName.replace('Component', '').toUpperCase()
                });
              }
            }
          }

          // Rename "Suggested" labels to "Marketplace"
          this.WidgetList = this.WidgetList.map(item => {
            if (item.widgetDesc === 'Suggested Jobs') {
              return { ...item, widgetDesc: 'Marketplace Jobs' };
            }
            if (item.widgetDesc === 'Suggested Candidates') {
              return { ...item, widgetDesc: 'Marketplace Candidates' };
            }
            return item;
          });

         // this.util.stopLoader();
        }
      }, err => {
        // this.util.stopLoader();
      });
    }
  }

  uniqBy(list, key) {
    let seen = new Set();
    return list.filter(item => {
        let k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
  }
}
